import { render, staticRenderFns } from "./foreign_trade_category.vue?vue&type=template&id=6658b74a&"
import script from "./foreign_trade_category.vue?vue&type=script&lang=js&"
export * from "./foreign_trade_category.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports